// api/candidateApi.js

import axiosInstance from "./axiosInstance";

export const getApplications = async (
  page = 1,
  limit = 10,
  search = "",
  position
) => {
  const response = await axiosInstance.get(
    `/application/list?page=${page}&limit=${limit}&search=${search}&position_id=${position}`
  );

  return response.data;
};

/*
|--------------------------------------------------------------------------
| Bench Sales By ID
|--------------------------------------------------------------------------
*/

export const getBenchSalesById = async (id) => {
  const response = await axiosInstance.get(
    `/benchsales/${id}`
  );

  return response.data;
};

/*
|--------------------------------------------------------------------------
| Bench Sales
|--------------------------------------------------------------------------
*/

export const getBenchSalesData = async (
  page = 1,
  limit = 10,
  search = "",
  filters = {}
) => {
  const response = await axiosInstance.get(
    "/benchsales/list",
    { params: { page, limit, search, ...filters } }
  );

  return response.data;
};

export const createBenchSalesApplication = async (formData) => {
  const response = await axiosInstance.post(
    "/benchsales/create",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};


export const getDashboardSummary = async (params = {}) => {
  const response = await axiosInstance.get(
    "/application/dashboard/summary",
    { params }
  );

  return response.data?.data ?? response.data;
};

export const getDashboardTable = async (table, params = {}) => {
  const response = await axiosInstance.get(`/dashboard/${table}`, { params });
  return response.data;
};

export const getDashboardRecord = async (table, id) => {
  const response = await axiosInstance.get(`/dashboard/${table}/${id}`);
  return response.data;
};

export const getExecutiveDashboardSummary = async () => {
  const response = await axiosInstance.get("/dashboard/executive-summary");
  return response.data?.data ?? response.data;
};

export const getDashboardActivities = async (limit = 30) => {
  const response = await axiosInstance.get("/dashboard/activities", { params: { limit } });
  return response.data?.data ?? [];
};

export const getWorkforceAnalytics = async (employeeId, period = "this_week", category = "all") => {
  const response = await axiosInstance.get("/dashboard/workforce-analytics", {
    params: {
      ...(employeeId ? { employee_id: employeeId } : {}),
      period,
      category,
    },
  });
  return response.data?.data ?? response.data;
};

export const getProfilePerformance = async ({ candidateId, userId, page = 1, limit = 10, relatedId, period, startDate, endDate }) => {
  const response = await axiosInstance.get("/dashboard/profile-performance", {
    params: {
      ...(candidateId ? { candidate_id: candidateId } : {}),
      ...(userId ? { user_id: userId } : {}),
      page,
      limit,
      ...(relatedId ? { related_id: relatedId } : {}),
      ...(period ? { period } : {}),
      ...(startDate ? { start_date: startDate } : {}),
      ...(endDate ? { end_date: endDate } : {}),
    },
  });
  return response.data?.data ?? response.data;
};

export const getRecruiterApplications = async (page = 1, limit = 10, search = "", filters = {}) => {
  const response = await axiosInstance.get("/recruiters/list", { params: { page, limit, search, ...filters } });
  return response.data;
};

export const getRecruiterApplicationById = async (id) => {
  const response = await axiosInstance.get(`/recruiters/${id}`);
  return response.data;
};

export const createRecruiterApplication = async (formData) => {
  const response = await axiosInstance.post("/recruiters/create", formData);
  return response.data;
};

export const updateRecruiterApplication = async (id, formData) => {
  const response = await axiosInstance.put(`/recruiters/update/${id}`, formData);
  return response.data;
};

export const deleteRecruiterApplication = async (id) => {
  const response = await axiosInstance.delete(`/recruiters/delete/${id}`);
  return response.data;
};

export const updateRecruiterApplicationProcess = async (id, processId, details = {}) => {
  const response = await axiosInstance.put(`/recruiters/process/${id}`, { process_id: processId, ...details });
  return response.data;
};

export const getSubmissionAnalytics = async (params = {}) => {
  const response = await axiosInstance.get(
    `/application/dashboard/submissions`,
    { params }
  );

  const payload = response.data;

  if (Array.isArray(payload)) {
    return { data: payload };
  }

  if (Array.isArray(payload?.data)) {
    return {
      data: payload.data,
      total: payload.total,
    };
  }

  if (payload?.data && typeof payload.data === "object") {
    return payload.data;
  }

  return payload || { data: [], total: 0 };
};

export const createApplication = async (formData) => {
  const response = await axiosInstance.post(
    "/application/create",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};

export const updateBenchSalesApplication = async (id, data) => {
  console.log("Form Date", Object.fromEntries(data.entries()));

  const response = await axiosInstance.put(
    `/benchsales/update/${id}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};


export const deleteBenchSalesApplication = async (id) => {
  const response = await axiosInstance.delete(
    `/benchsales/delete/${id}`
  );

  return response.data;
};

export const getPerformanceDashboard = async (params = {}) => {
  const response = await axiosInstance.get(
    "/benchsales/dashboard/performance",
    { params }
  );
  return response.data;
};

export const getRecruiterPerformanceDashboard = async (params = {}) => {
  const response = await axiosInstance.get(
    "/recruiters/dashboard/performance",
    { params }
  );
  return response.data;
};

export const updateApplicationProcess = async (id, processId, details = {}) => {
  const response = await axiosInstance.put(
    `/benchsales/process/${id}`,
    {
      process_id: processId,
      ...details,
    }
  );

  return response.data;
};
